// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_eb-0";
export var actionModalContentContainer = "_eb-1";
export var createTagButton = "_eb-2";
export var footerContainer = "_eb-7";
export var fullWidthDivider = "_eb-3";
export var hasCreateTagButton = "_eb-4";
export var noCreateTagButton = "_eb-5";
export var tagsContainer = "_eb-6";
export var tagsModalContentContainer = "_eb-8";